module.exports = __webpack_public_path__ + "2a4710132a41585499be060b10f35103.MP3";